import React from 'react'
import contactSample from 'images/content/contect_us-2048x1498-1-1536x1124.png'

const CallToActionPHI = () => {
    return (
        <div className='grid grid-cols-1 lg:grid-cols-2'>
            <div className='flex items-center'><img src={contactSample} alt='Telephone' /></div>
            <div className='flex flex-col justify-center space-y-4'>
                <div className='text-2xl sm:text-4xl font-bold'>Contact Insurance Enterprise for your Health Insurance</div>
                <div>
                    If you have questions about group or individual health insurance and need health insurance quotes,
                    then contact Insurance Enterprise at <a href='#?' className='text-secondary hover:underline'>888-350-6605</a>. Speak to a licensed real estate broker and find out more about how you
                    can get an affordable health insurance plan.
                </div>
            </div>
        </div>
    )
}

export default CallToActionPHI